import { startAuthentication, startRegistration, browserSupportsWebAuthn, platformAuthenticatorIsAvailable } from "@simplewebauthn/browser";
import { api } from "@/lib/api";

const FLAG = "amc-bio-enabled";
const DISMISS = "amc-bio-dismissed";

export const bioFlag = () => localStorage.getItem(FLAG) === "1";
export const bioDismissed = () => localStorage.getItem(DISMISS) === "1";
export const dismissBio = () => localStorage.setItem(DISMISS, "1");

export const bioAvailable = async () => browserSupportsWebAuthn() && (await platformAuthenticatorIsAvailable().catch(() => false));

const errMsg = (e, fallback) => (e?.name === "NotAllowedError" ? "Biometria cancelada ou tempo esgotado." : e?.response?.data?.detail || fallback);

export const enableBio = async () => {
  try {
    const { data } = await api.post("/auth/webauthn/register/options");
    const cred = await startRegistration({ optionsJSON: data });
    await api.post("/auth/webauthn/register/verify", cred);
    localStorage.setItem(FLAG, "1");
    localStorage.removeItem(DISMISS);
    return { ok: true };
  } catch (e) {
    return { ok: false, error: errMsg(e, "Não foi possível ativar a biometria.") };
  }
};

export const loginBio = async () => {
  try {
    const { data } = await api.post("/auth/webauthn/login/options");
    const cred = await startAuthentication({ optionsJSON: data });
    const r = await api.post("/auth/webauthn/login/verify", cred);
    return { ok: true, user: r.data };
  } catch (e) {
    if (e?.response?.status === 404) localStorage.removeItem(FLAG);
    return { ok: false, error: errMsg(e, "Biometria não reconhecida. Entre com a senha.") };
  }
};

export const disableBio = async () => {
  await api.delete("/auth/webauthn/device");
  localStorage.removeItem(FLAG);
};
